<div class="container-fluid">
  <div class="row">
    <div class="col-12">
      <div class="card">
        <div class="card-header">
          <h4 class="card-title">Upload Blocked CPR Numbers</h4>
        </div>
        <div class="card-body">
          <div class="row mb-4">
            <div class="col-md-12">
              <div class="alert alert-info">
                <p class="mb-0">Upload a CSV file containing CPR numbers to block.</p>
                <p class="mb-0">The CSV file should have the following format:</p>
                <pre class="mt-2 mb-0">cprNumber,reason
1234567890,Suspected fraud
1234567891,Test blocking
1234567892,</pre>
                <p class="mb-0 mt-2">
                  <strong>Note:</strong> The first row should contain column headers. The 'reason' column is optional.
                </p>
              </div>
            </div>
          </div>
          
          <form>
            <div class="row">
              <div class="col-md-12 mb-3">
                <label for="csvFile" class="form-label">CSV File</label>
                <input 
                  type="file" 
                  class="form-control" 
                  id="csvFile" 
                  accept=".csv"
                  (change)="onFileSelected($event)"
                  [ngClass]="{'is-invalid': fileError}"
                >
                <div *ngIf="fileError" class="invalid-feedback">
                  {{ fileError }}
                </div>
                <small class="form-text text-muted">
                  Select a CSV file with CPR numbers to upload
                </small>
              </div>
            </div>
            
            <div *ngIf="success" class="alert alert-success mt-3">
              <p class="mb-0">CSV file uploaded successfully!</p>
              <p *ngIf="results" class="mb-0">Processed: {{results.total}}, Successfully blocked: {{results.success}}</p>
            </div>
            
            <div *ngIf="errors && errors.length > 0" class="alert alert-danger mt-3">
              <p class="mb-0">The following errors occurred:</p>
              <ul class="mb-0">
                <li *ngFor="let error of errors">{{ error }}</li>
              </ul>
            </div>
            
            <div class="row mt-4">
              <div class="col-md-12">
                <button type="button" class="btn btn-primary me-2" [disabled]="!selectedFile || uploading" (click)="onUpload()">
                  <span *ngIf="uploading" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                  Upload CSV
                </button>
                <button type="button" class="btn btn-secondary" (click)="goBack()">Cancel</button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div> 